import { Grid } from "@mui/material";
import "react-dropzone-uploader/dist/styles.css";
import {
  getParams,
  navigate,
  sendGetRequest,
  sendPostRequest,
  removeEmpty,
  allowedOperations,
  watchLiveData,
} from "../utils/utils";
import EditPage from "./component/edit-page";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";
import EasyTextEdit from "./component/text-edit";
import {
  Dropzone,
  FileMosaic,
  FullScreen,
  VideoPreview,
} from "@files-ui/react";
import {
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import { useSelector } from "react-redux";

const _ref = {
  uuid: "",
  source: "s3",
  location: null,
  s3Url: "",
};



const BackgroundMusic = () => {
  const { uuid } = getParams();
  var [setting, setSetting] = useState(_ref);
  var [urlError, setUrlError] = useState(false);
  var [files, setFiles] = useState([]);
  const [videoSrc, setVideoSrc] = useState(undefined);
  const { canCreate } = allowedOperations();
  const { queue } = useSelector((state) => state.queue);
  const [requestId, setRequestId] = useState(null);

  const [status, setStatus] = useState({
    error: false,
    loading: false,
    message: null,
    progress: null
  });

  const updateFiles = (selectedFiles) => {
    const audio = [];
    selectedFiles.forEach((file) => {
      if (file.type.startsWith("audio")) audio.push(file);
    });

    if (audio.length === 1) {
      setFiles(selectedFiles);
    }
  };


  useEffect(() => {
    setRequestId(generateUniqueId())
    setStatus({ ...{ loading: true } });
    sendGetRequest(`music?uuid=${uuid}`).then((result) => {
      setSetting({ ..._ref, ...result });
      setStatus({ ...{ loading: false } });
    })
    return () => setSetting(_ref);
    // eslint-disable-next-line
  }, [uuid]);

  const getMusic = () => {
    const formData = new FormData();
    const _setting = removeEmpty(setting);
    for (const [key, value] of Object.entries({ ..._setting })) {
      formData.append(key, value);
    }
    if (files.length === 1) {
      files.forEach((file) => {
        formData.append("files", file.file);
      });
    }
    return {
      form: formData,
    };
  };

  const showUrlOps = () => setting.source === "s3";

  const onValueChange = (value, tag) => {
    setSetting({ ...setting, [tag]: value });
    const error = !(
      `${value}`.startsWith("s3://") &&
      `${value}`.includes(".") &&
      `${value}`.split(".").length >= 2
    );
    if (tag === "s3Url") setUrlError(error);
  };

  const onDelete = (id) => {
    setFiles(files.filter((_file) => _file.id !== id));
  };

  const handleWatch = (videoSource) => {
    setVideoSrc(videoSource);
  };

  const checkPropsValidity = () => {
    const isS3Validsource =
      setting.source === "s3" && !files.length && !urlError;
    const isFileValidSource =
      files.length && setting.source !== "s3" && setting.location !== null;
    return isS3Validsource || isFileValidSource;
  };

  const createUpdate = () => {
    sendPostRequest(
      "music",
      getMusic().form,
      (loading) => setStatus({ ...{ loading: loading } }),
      (data) => {
        setStatus({
          ...{
            error: data.error,
            message: data.message,
          },
        });
      }, requestId
    );
  };

  useEffect(() => {
      if (queue)
        watchLiveData(queue, "progress", ({ requestId: id, progress }) => {
          if (id === requestId) setStatus({ ...status, progress, loading: true });
        });
      // eslint-disable-next-line
    }, [queue]);

  return (
    <EditPage
      title={"Background Music"}
      status={status}
      btnLabel={canCreate ? "Add Now" : null}
      onSave={() => createUpdate()}
      spacing={5}
      onBack={() =>
        navigate(`${AppRoutes.appSettings}/${AppRoutes.backgroundMusics}`, true)
      }
      validated={checkPropsValidity()}
      onFinish={() => {
        setStatus({ ...{ loading: false, message: null, error: false } });
        if (!status.error) {
          setSetting({ ..._ref });
          navigate(
            `${AppRoutes.appSettings}/${AppRoutes.backgroundMusics}`,
            true
          );
        }
      }}
    >
      <Grid item md={showUrlOps() ? 3 : 12} xs={12}>
        <FormControl sx={{ minWidth: 50 }} fullWidth>
          <InputLabel id="content-source">Music Source</InputLabel>
          <Select
            value={setting.source || "s3"}
            label="Music Source"
            labelId="content-source"
            id="source"
            disabled={status.loading}
            onChange={(e) => onValueChange(e.target.value, "source")}
          >
            {[
              { name: "S3 URLS", value: "s3" },
              { name: "File Upload", value: "file" },
            ].map((souces) => {
              return (
                <MenuItem value={souces.value} id={souces.value}>
                  &nbsp;&nbsp;&nbsp;{souces.name}
                  <br />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>

      {showUrlOps() && (
        <Grid item md={9} xs={12}>
          <EasyTextEdit
            placeholder="S3 file URI i.e s3://bucket-id/folder/directory/audio.mp3"
            label="Actual music content url (Audio)"
            type="text"
            textField={true}
            error={urlError}
            id="url"
            errorText={urlError ? "Make sure you fill in AWS s3 file URI" : ""}
            disabled={status.loading}
            value={setting.s3Url}
            onChange={onValueChange}
          />
        </Grid>
      )}

      {setting.source === "file" && (
        <Grid item xs={12} xl={12}>
          <Dropzone
            onChange={updateFiles}
            value={files}
            minHeight="195px"
            maxFiles={1}
            accept={"audio/*"}
            maxFileSize={1024 * 1024 * 5}
            label="Drag'n drop audio here or click to browse"
          >
            {files.map((file) => (
              <FileMosaic
                {...file}
                resultOnTooltip
                alwaysActive
                preview
                info
                onDelete={onDelete}
                onWatch={handleWatch}
              />
            ))}
          </Dropzone>

          <FullScreen
            open={videoSrc !== undefined}
            onClose={() => setVideoSrc(undefined)}
          >
            <VideoPreview src={videoSrc} autoPlay controls />
          </FullScreen>
        </Grid>
      )}
    </EditPage>
  );
};

export default BackgroundMusic;
